
export enum TicketPrintFormat {
  A4 = 'A4',
  Boca6x11 = 'Boca6x11',
  Boca6x11Reverse = 'Boca6x11Reverse',
  Boca152x51 = 'Boca152x51',
  Boca152x51Reverse = 'Boca152x51Reverse',
}
